module.exports = __webpack_public_path__ + "common/tp-featured6-50c095f76bb2ae4618e4026ca7833ecf.svg";